export enum I18nLanguageEnum {
    //简体中文
    ZH_CN,
    //繁体中文
    ZH_TC,
    //英文
    ENGLISH,
}

export interface I18nKV {
    [k: string]: string[];
}